import moment from "moment";
import Dashboard from "../utils/services/dashboardServise";
import debounce from "../../assets/js/debounce";
const state = {
  layout: []
};

const updateDashboard = debounce(Dashboard.update, 500);
const getters = {
  getLayout(state) {
    return state.layout;
  },
  getRelativeIntervals() {
    let today = moment().format("YYYY-MM-DD"),
      format = "YYYY-MM-DD";
    return [
      {
        title: "analysis.hourly",
        items: [
          {
            title: "analysis.last-2-days",
            item: {
              interval: "hour",
              date_from: moment()
                .subtract(2, "days")
                .format(format),
              date_to: today,
              time_mode: "last"
            }
          },
          {
            title: "analysis.past-2-days",
            item: {
              interval: "hour",
              date_from: moment()
                .startOf("day")
                .subtract(2, "day")
                .format(format),
              date_to: moment()
                .endOf("day")
                .subtract(1, "day")
                .format(format),
              time_mode: "past"
            }
          }
        ]
      },
      {
        title: "analysis.daily",
        items: [
          {
            title: "analysis.last-4-weeks",
            item: {
              interval: "day",
              date_from: moment()
                .subtract(4, "week")
                .format(format),
              date_to: today,
              time_mode: "last"
            }
          },
          {
            title: "analysis.past-4-weeks",
            item: {
              interval: "day",
              date_from: moment()
                .startOf("week")
                .subtract(4, "week")
                .format(format),
              date_to: moment()
                .endOf("week")
                .subtract(1, "week")
                .format(format),
              time_mode: "past"
            }
          }
        ]
      },

      {
        title: "analysis.weekly",
        items: [
          {
            title: "analysis.last-12-months",
            item: {
              interval: "week",
              date_from: moment()
                .subtract(12, "month")
                .format(format),
              date_to: today,
              time_mode: "last"
            }
          },
          {
            title: "analysis.past-12-months",
            item: {
              interval: "week",
              date_from: moment()
                .startOf("month")
                .subtract(12, "month")
                .format(format),
              date_to: moment()
                .endOf("month")
                .subtract(1, "month")
                .format(format),
              time_mode: "past"
            }
          }
        ]
      },
      {
        title: "analysis.monthly",
        items: [
          {
            title: "analysis.last-3-years",
            item: {
              interval: "month",
              date_from: moment()
                .subtract(3, "year")
                .format(format),
              date_to: today,
              time_mode: "last"
            }
          },
          {
            title: "analysis.past-3-years",
            item: {
              interval: "month",
              date_from: moment()
                .startOf("year")
                .subtract(3, "year")
                .format(format),
              date_to: moment()
                .endOf("year")
                .subtract(1, "year")
                .format(format),
              time_mode: "past"
            }
          }
        ]
      }
    ];
  }
};

const actions = {
  getLayout({ commit }, { onSuccess = () => {} }) {
    Dashboard.get(layout => {
      commit("set", {
        layout
      });
      onSuccess();
    });
  },
  add({ commit }, { item = {}, onSuccess = () => {} }) {
    commit("add", {
      item
    });
    onSuccess();
  },
  edit({ commit }, { widget = {}, onSuccess = () => {} }) {
    commit("edit", {
      widget
    });

    onSuccess();
  },
  set({ commit }, { layout = {}, onSuccess = () => {} }) {
    commit("set", {
      layout
    });

    onSuccess();
  },
  delete({ commit }, { widget, onSuccess = () => {} }) {
    commit("delete", {
      widget
    });
    onSuccess();
  }
};

const mutations = {
  add(state, { item }) {
    let y = Math.max.apply(Math, [
      -1,
      ...state.layout.map(function(o) {
        return o.y;
      })
    ]);
    let i = Math.max.apply(Math, [
      0,
      ...state.layout.map(function(o) {
        return o.i;
      })
    ]);
    i++;
    let x = 0;
    let lastRow = state.layout.filter(o => o.y === y);
    if (lastRow.length === 0 || lastRow.length >= 2) {
      y++;
    } else {
      lastRow[0].x === 0 ? (x = 1) : (x = 0);
    }
    state.layout.push({ x, y, w: 1, h: 1, i, item });
    updateDashboard(state.layout);
  },
  edit(state, { widget }) {
    let item = state.layout.find(i => i.i === widget.i);
    if (!item) {
      return;
    }
    state.layout = state.layout.filter(i => i.i !== widget.i);
    state.layout.push(widget);
    updateDashboard(state.layout);
  },
  set(state, { layout }) {
    state.layout = layout;
    updateDashboard(state.layout);
  },
  delete(state, { widget }) {
    state.layout = state.layout.filter(i => i.i !== widget.i);
    updateDashboard(state.layout);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
